import * as React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import "../Amenities.css"

import NoCrashIcon from '@mui/icons-material/NoCrash';
import CarCrashIcon from '@mui/icons-material/CarCrash';

import Container from '@mui/material/Container';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Grid from '@mui/material/Grid';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';

import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';

import apiClient, { shouldRedirectToLogin, getErrorMessage } from '../services/api-client';
import AppConfig from '../services/app-config';
import AuthService from '../services/auth.js';
import { CardHeader } from '@mui/material';
import ArrowCircleRightIcon from '@mui/icons-material/ArrowCircleRight';
import PersonIcon from '@mui/icons-material/Person';
import AccessTimeIcon from '@mui/icons-material/AccessTime';

import Drawer from '@mui/material/Drawer';
import TextField from '@mui/material/TextField';

import HotelIcon from '@mui/icons-material/Hotel';
import NightShelterIcon from '@mui/icons-material/NightShelter';
import QrCodeIcon from '@mui/icons-material/QrCode';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import ShareIcon from '@mui/icons-material/Share';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { QRCodeSVG } from 'qrcode.react';

import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import AutorenewIcon from '@mui/icons-material/Autorenew';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { alpha } from '@mui/material/styles';
import InputAdornment from '@mui/material/InputAdornment';
import SearchIcon from '@mui/icons-material/Search';

import Modal from '@mui/material/Modal';
import LoupeIcon from '@mui/icons-material/Loupe';

export default function ParkingShare({setNavbarState, navbarState}) {
  const [redirect, setRedirect] = React.useState({ trigger: false, route: '/' });
  const [loading, setLoading] = React.useState(true);
  const [currentReservations, setCurrentReservations] = React.useState([]);
  const [pastReservations, setPastReservations] = React.useState([]);
  const [showBackdrop, setShowBackdrop] = React.useState(false);
  const [tabValue, setTabValue] = React.useState('current');
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' });
  const [drawerShow, setDrawerShow] = React.useState(false);
  const [searchValue, setSearchValue] = React.useState('');
  const [showSearch, setShowSearch] = React.useState(false);
  const searchInputRef = React.useRef(null);
  const [newReservationDateStart, setNewReservationDateStart] = React.useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 1);
    return tomorrow.toISOString().split('T')[0];
  });
  
  const [newReservationDateEnd, setNewReservationDateEnd] = React.useState(() => {
    const tomorrow = new Date();
    tomorrow.setDate(tomorrow.getDate() + 3);
    return tomorrow.toISOString().split('T')[0];
  });
  const [newReservationGuestName, setNewReservationGuestName] = React.useState('');
  const [newReservationCheckIn, setNewReservationCheckIn] = React.useState(AppConfig.getf('reservationCheckIn', '15:00'));
  const [newReservationCheckOut, setNewReservationCheckOut] = React.useState(AppConfig.getf('reservationCheckOut', '13:00'));
  const [newReservatinGuests, setNewReservationGuests] = React.useState(AppConfig.getf('reservationGuests', '2'));

  const [currentDateTime, setCurrentDateTime] = React.useState('');
  const navigate = useNavigate();
  let tab = new URLSearchParams(location.search).get('tab');

  const apiUrl = process.env.REACT_APP_MGO_API_URL;
  
  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setShowSearch(false);
    setSearchValue('');
    fetchInfo(newValue);
  }

  const handleSearchChange = (event) => {
    setSearchValue(event.target.value);
  };

  const handleToggleSearch = () => {
    setShowSearch((prev) => {
      const next = !prev;
      if (!next) {
        setSearchValue('');
      }
      return next;
    });
  };

  const handleSnackbarClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbar({ ...snackbar, open: false });
  };

  const handleClick = (route) => {
    setRedirect({ trigger: true, route: `/${route.toLowerCase()}` })
}

  const cardStyle = {
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        '&:hover': {
            transform: 'translateY(-5px)',
            boxShadow: '0 4px 20px rgba(0,0,0,0.1)',
        },
    };

    const iconStyle = {
        position: 'absolute',
        right: -20,
        bottom: -20,
        fontSize: 105,
        color: 'rgba(0, 0, 0, 0.10)',
    };

  const fetchInfo = (currentTabValue) => {
    setShowBackdrop(true);
    setLoading(true);
    
    const endpoint = `airbnb/${currentTabValue}`;
    
    apiClient.get(endpoint, {}, { action: 'fetch_airbnb_data' })
      .then(response => {
        if (response.status === 200) {
          const dataArray = Object.entries(response.data.data).map(([id, value]) => ({ id, ...value }));
          if (currentTabValue === 'current') {
            setCurrentReservations(dataArray.reverse());
          } else {
            setPastReservations(dataArray.reverse());
          }
          setShowBackdrop(false);
          setLoading(false);
        }
      })
      .catch(error => {
        console.error('Error fetching parking requests:', error);
        if (error.response && error.response.data && error.response.data.code === 401) {
          setRedirect({ trigger: true, route: '/login' })
        }
      });
  }

  React.useEffect(() => {
    setNavbarState({...navbarState, showBack: true, showOptions: false, showSearch: false})
    if (AuthService.userRoleIncludes(["habitante"]) && AuthService.getCurrentUserRole() !== 'superuser') {
      if (AppConfig.get('unit_mode') !== 'airbnb') {
        setRedirect({ trigger: true, route: '/' });
      }
    }
    if (tab !== null) { 
      setRedirect({ trigger: true, route: '/' });
      setTabValue(tab);
    }
    fetchInfo(tabValue);

  }, [tabValue]);

  React.useEffect(() => {
    if (showSearch) {
      const timeoutId = setTimeout(() => {
        searchInputRef.current?.focus();
      }, 0);
      return () => clearTimeout(timeoutId);
    }
  }, [showSearch]);

  const filteredPastReservations = React.useMemo(() => {
    if (tabValue !== 'past') return pastReservations;
    const q = (searchValue || '').trim().toLowerCase();
    if (!q) return pastReservations;
    return pastReservations.filter((reservation) => {
      const guest = String(reservation?.main_guest || '').toLowerCase();
      const unit = String(reservation?.unit || '').toLowerCase();
      const checkin = String(reservation?.checkin || '').toLowerCase();
      const checkout = String(reservation?.expires || '').toLowerCase();
      return (
        guest.includes(q) ||
        unit.includes(q) ||
        checkin.includes(q) ||
        checkout.includes(q)
      );
    });
  }, [tabValue, pastReservations, searchValue]);

  const handleDrawerToggle = () => {
    setDrawerShow((prevState) => !prevState);
    // if (!drawerShow) {
    //   setNewReservationDateStart('');
    //   setNewReservationDateEnd('');
    // }
  };

  const handleNewRequest = () => {
    setDrawerShow(true);
  };

  const [isSubmitting, setIsSubmitting] = React.useState(false);

  const submitNewRequest = async () => {
    setIsSubmitting(true);
    try {
      if (!newReservationGuestName || !newReservationDateStart || !newReservationDateEnd || 
          !newReservationCheckIn || !newReservationCheckOut || !newReservatinGuests) {
        setSnackbar({ 
          open: true, 
          message: "Por favor, complete todos los campos requeridos", 
          severity: "warning" 
        });
        setIsSubmitting(false);
        return;
      }

      const checkinDateTime = new Date(`${newReservationDateStart}T${newReservationCheckIn}`);
      const checkoutDateTime = new Date(`${newReservationDateEnd}T${newReservationCheckOut}`);

      if (checkoutDateTime <= checkinDateTime) {
        setSnackbar({ 
          open: true, 
          message: "La fecha y hora de check-out debe ser posterior a la fecha y hora de check-in", 
          severity: "error" 
        });
        setIsSubmitting(false);
        return;
      }

      const payload = {
        main_guest: newReservationGuestName,
        guest_number: parseInt(newReservatinGuests),
        checkin_date: newReservationDateStart,
        checkin_hour: newReservationCheckIn,
        checkout_date: newReservationDateEnd,
        checkout_hour: newReservationCheckOut
      };

      apiClient.post('airbnb/create/reservation', payload, {}, { action: 'create_airbnb_reservation' })
        .then(response => {
          if (response.status === 200) {
            setSnackbar({ 
              open: true, 
              message: "Reservación registrada correctamente", 
              severity: "success" 
            });
            AppConfig.storeLocal('reservationCheckIn', newReservationCheckIn);
            AppConfig.storeLocal('reservationCheckOut', newReservationCheckOut);
            AppConfig.storeLocal('reservationGuests', newReservatinGuests);
            fetchInfo(tabValue);
            setDrawerShow(false);
            handleShareLink(response.data.data.id);
          }
        })
        .catch(error => {
          console.error('Error submitting Airbnb reservation:', error);
          if (error.response && error.response.data && error.response.data.code === 422) {
            setSnackbar({ 
              open: true, 
              message: error.response.data.msg, 
              severity: "error" 
            });
          } else {
            setSnackbar({ 
              open: true, 
              message: "Error al registrar la reservación", 
              severity: "error" 
            });
          }
        })
        .finally(() => {
          setIsSubmitting(false);
        });
    } catch (error) {
      console.error('Error submitting Airbnb reservation:', error);
      setIsSubmitting(false);
    }
  };

  const newRequestDrawer = (
    <Card sx={{ py: 3, px: 2, display: 'block', marginLeft: 'auto', marginRight: 'auto', borderTopLeftRadius: "20px", borderTopRightRadius: "20px", borderBottomRightRadius: "0px", borderBottomLeftRadius: "0px", maxWidth: "550px" }}>
      <CardContent>
        <Typography gutterBottom variant="h5" component="div" sx={{ mb: 2 }}>
          Registrar Estadia
        </Typography>
        <TextField
          sx={{ mb: 2 }}
          fullWidth
          size="medium"
          value={newReservationDateStart}
          id='timeStart'
          label="Fecha Check-In"
          type="date"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            setNewReservationDateStart(e.target.value);
          }}
        />
        <TextField
          sx={{ mb: 4 }}
          fullWidth
          size="medium"
          value={newReservationCheckIn}
          id='checkin'
          label="Hora Check-In"
          type="time"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            setNewReservationCheckIn(e.target.value);
          }}
        />
        <TextField
          sx={{ mb: 2 }}
          fullWidth
          size="medium"
          value={newReservationDateEnd}
          id='timeEnd'
          label="Fecha Check-Out"
          type="date"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            setNewReservationDateEnd(e.target.value);
          }}
        />
        <TextField
          sx={{ mb: 4 }}
          fullWidth
          size="medium"
          value={newReservationCheckOut}
          id='checkout'
          label="Hora Check-Out"
          type="time"
          variant="outlined"
          InputLabelProps={{ shrink: true }}
          onChange={(e) => {
            setNewReservationCheckOut(e.target.value);
          }}
        />
        <TextField
          sx={{ my: 2 }}
          fullWidth
          value={newReservationGuestName}
          onChange={(e) => {
            setNewReservationGuestName(AppConfig.titleCase(e.target.value));
          }}
          label="Nombre del Huesped Principal"
          variant="outlined"
        />

        <TextField
          sx={{ mb: 2 }}
          fullWidth
          type="number"
          value={newReservatinGuests}
          onChange={(e) => {
            setNewReservationGuests(e.target.value);
          }}
          label="Cantidad de Huespedes"
          variant="outlined"
          inputProps={{
            min: 1,
            max: 16
          }}
        />
      </CardContent>
      <CardActions sx={{ justifyContent: 'flex-end' }}>
        <Button size="medium" onClick={handleDrawerToggle} color="inherit" variant="text" sx={{ mr: 1 }}>Cancelar</Button>
        <Button 
          size="medium" 
          onClick={submitNewRequest} 
          color="secondary" 
          sx={{ px: 4 }} 
          variant="contained"
          disabled={isSubmitting}
          endIcon={isSubmitting && <CircularProgress size={20} color="inherit" />}
        >
          {isSubmitting ? 'Registrando...' : 'Registrar'}
        </Button>
      </CardActions>
    </Card>
  );

  const [shareLinkOpen, setShareLinkOpen] = React.useState(false);
  const [selectedReservationId, setSelectedReservationId] = React.useState(null);
  const [snackbarOpen, setSnackbarOpen] = React.useState(false);

  const handleShareLink = (reservationId) => {
    setSelectedReservationId(reservationId);
    setShareLinkOpen(true);
  };

  const handleCloseShareLink = () => {
    setShareLinkOpen(false);
    setSelectedReservationId(null);
  };

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text);
    setSnackbarOpen(true);
  };

  const getGuestFormLink = (reservationId) => {
    return `${window.location.origin}/guestform?id=${reservationId}`;
  };

  const handleViewDetails = (requestId) => {
    navigate(`/solicitudparqueo?id=${requestId}`);
  };

  const [openQrModal, setOpenQrModal] = React.useState(false);
  const [currentReservationId, setCurrentReservationId] = React.useState(null);
  const [linkCopied, setLinkCopied] = React.useState(false);

  const handleCopyLink = (reservationId) => {
    const link = `${window.location.origin}/guestform?id=${reservationId}`;
    navigator.clipboard.writeText(link).then(() => {
      setLinkCopied(true);
      setTimeout(() => setLinkCopied(false), 2000);
    });
  };

  const handleShareClick = (reservationId) => {
    setCurrentReservationId(reservationId);
    setOpenQrModal(true);
  };

  const cardSx = {
    borderRadius: '10px',
    boxShadow: 0,
    border: '1px solid',
    borderColor: 'divider',
  };

  const renderReservationCard = (reservation, isPast) => (
    <Card key={reservation.id} sx={{ ...cardSx, cursor: 'pointer' }} onClick={() => navigate(`/airbnb/reservacion/${reservation.id}`)}>
      <CardContent sx={{ p: 2.25, '&:last-child': { pb: 2.25 } }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, mb: 1.5 }}>
          <img src="/airbnb-logo.png" alt="Airbnb" style={{ width: 24, height: 24 }} />
          <Typography sx={{ fontSize: 15, fontWeight: 800, color: 'text.primary' }}>
            {reservation.main_guest}
          </Typography>
        </Box>
        {AuthService.userRoleIncludes(["admin","receptor"]) && (
          <Box sx={{ mb: 1 }}>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>
              {AppConfig.get('unit_type')}
            </Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 700, color: 'text.primary' }}>
              {reservation.unit}
            </Typography>
          </Box>
        )}
        <Box sx={{ display: 'flex', gap: 3, mb: 1 }}>
          <Box>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Ingreso</Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>{AppConfig.formatFriendlyDate(reservation.checkin)}</Typography>
          </Box>
          <Box>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Salida</Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>{AppConfig.formatFriendlyDate(reservation.expires)}</Typography>
          </Box>
          <Box sx={{ ml: 'auto' }}>
            <Typography sx={{ fontSize: 11, fontWeight: 700, color: 'text.secondary', textTransform: 'uppercase', letterSpacing: 0.5 }}>Huéspedes</Typography>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.primary' }}>{reservation.guest_number}</Typography>
          </Box>
        </Box>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1.5, flexWrap: 'wrap' }}>
          {isPast ? (
            <Chip size="small" icon={<CheckCircleIcon />} label="Reserva Finalizada" sx={{ fontWeight: 700, fontSize: 11 }} />
          ) : (
            <>
              <Chip
                size="small"
                icon={reservation.guest_checked_in ? <CheckCircleIcon style={{ color: '#238048' }} /> : reservation.info_submitted ? <CheckCircleIcon style={{ color: '#238048' }} /> : <AutorenewIcon />}
                label={reservation.guest_checked_in ? "Huespedes Ingresados" : reservation.info_submitted ? 'Formulario Completado' : 'Formulario Pendiente'}
                sx={{ fontWeight: 700, fontSize: 11 }}
              />
              {!reservation.info_submitted && (
                <Chip
                  size="small"
                  icon={AuthService.getCurrentUserRole() === "habitante" ? <ShareIcon /> : <QrCodeIcon />}
                  label="Enlace"
                  color='primary'
                  sx={{ fontWeight: 700, fontSize: 11 }}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShareClick(reservation.id);
                  }}
                />
              )}
            </>
          )}
        </Box>
      </CardContent>
    </Card>
  );

  const renderEmptyState = (message, subtitle) => (
    <Card sx={{ ...cardSx, textAlign: 'center', py: 6 }}>
      <CardContent>
        <img src="/airbnb-logo.png" alt="Airbnb" style={{ width: 64, height: 64, marginBottom: 16 }} />
        <Typography sx={{ fontSize: 16, fontWeight: 800, color: 'text.primary', mb: 1 }}>{message}</Typography>
        <Typography sx={{ fontSize: 13, fontWeight: 600, color: 'text.secondary' }}>{subtitle}</Typography>
      </CardContent>
    </Card>
  );

  return (
    <Container maxWidth="sm" disableGutters>
      {redirect.trigger && (
        <Navigate to={redirect.route} replace={true} />
      )}
      <Snackbar open={snackbar.open} autoHideDuration={8000} anchorOrigin={{ vertical: "top", horizontal: "center" }} sx={{mt: "3.2rem"}} onClose={handleSnackbarClose}>
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity}>
          {snackbar.message}
        </Alert>
      </Snackbar>
      <Backdrop open={showBackdrop} sx={{ zIndex: (theme) => theme.zIndex.drawer + 1, color: '#fff' }}>
        <CircularProgress color="inherit" />
      </Backdrop>
      <Box sx={{ minHeight: '100vh', bgcolor: 'background.default', pb: 10 }}>
        <Box
          sx={{
            position: 'sticky',
            top: 0,
            zIndex: 10,
            px: 3,
            pt: 2,
            pb: 1.5,
            backgroundColor: (theme) => alpha(theme.palette.background.paper, 0.95),
            backdropFilter: 'blur(10px)',
          }}
        >
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <IconButton
              onClick={() => navigate(-1)}
              sx={{
                width: 40,
                height: 40,
                ml: -1,
                color: 'text.primary',
                '&:hover': { backgroundColor: (theme) => alpha(theme.palette.text.primary, 0.08) },
              }}
            >
              <ArrowBackIcon sx={{ fontSize: 28 }} />
            </IconButton>
            <Typography sx={{ fontSize: 24, fontWeight: 800, lineHeight: 1.1, letterSpacing: '-0.02em', color: 'text.primary' }}>
              Airbnb
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: tabValue === 'past' && showSearch ? 1 : 0 }}>
            <Stack direction="row" spacing={1} sx={{ flexGrow: 1, overflowX: 'auto', pb: 0.5 }}>
              <Chip
                label="Próximas Estadías"
                clickable
                color={tabValue === 'current' ? 'primary' : 'default'}
                variant={tabValue === 'current' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'current')}
                sx={{ fontWeight: 700 }}
              />
              <Chip
                label="Estadías Pasadas"
                clickable
                color={tabValue === 'past' ? 'primary' : 'default'}
                variant={tabValue === 'past' ? 'filled' : 'outlined'}
                onClick={(e) => handleTabChange(e, 'past')}
                sx={{ fontWeight: 700 }}
              />
            </Stack>

            <IconButton
              onClick={handleToggleSearch}
              sx={{
                width: 40,
                height: 40,
                borderRadius: '10px',
                border: '1px solid',
                borderColor: 'divider',
                color: 'text.primary',
                display: tabValue === 'past' ? 'inline-flex' : 'none'
              }}
            >
              <SearchIcon />
            </IconButton>
          </Box>

          {tabValue === 'past' && showSearch && (
            <TextField
              fullWidth
              size="small"
              id="search"
              sx={{ textAlign: 'center', mb: 0, mt: 0.5 }}
              label="Buscar"
              variant="outlined"
              value={searchValue}
              onChange={handleSearchChange}
              inputRef={searchInputRef}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton onClick={handleToggleSearch}>
                      <SearchIcon />
                    </IconButton>
                  </InputAdornment>
                ),
                style: { borderRadius: '8px' }
              }}
            />
          )}
        </Box>

        <Box sx={{ px: 3, mt: 1.5 }}>
          {tabValue === "past" ? (
            <>
              {!loading && (
                filteredPastReservations.length === 0
                  ? renderEmptyState('No hay estadías pasadas', 'Aquí podrás ver las estadías pasadas de tu Airbnb.')
                  : <Stack spacing={1.5}>{filteredPastReservations.map((r) => renderReservationCard(r, true))}</Stack>
              )}
            </>
          ) : (
            <>
              {!loading && (
                currentReservations.length === 0
                  ? renderEmptyState('No tienes estadías programadas', 'Si tienes una estadía regístrala aquí para agilizar el ingreso de tus huéspedes.')
                  : <Stack spacing={1.5}>{currentReservations.map((r) => renderReservationCard(r, false))}</Stack>
              )}
            </>
          )}
        </Box>
      </Box>
      <Drawer
        anchor="bottom"
        open={drawerShow}
        onClose={handleDrawerToggle}
        ModalProps={{
          keepMounted: true,
        }}
        PaperProps={{ elevation: 0, style: { backgroundColor: "transparent" } }}
        sx={{
          display: { xs: 'block' },
          '& .MuiDrawer-paper': { boxSizing: 'border-box', width: '440' },
        }}
      >
        {newRequestDrawer}
      </Drawer>
      <Modal
        open={shareLinkOpen}
        onClose={handleCloseShareLink}
        aria-labelledby="share-link-modal"
        aria-describedby="modal-to-share-guest-form-link"
      >
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: 500 },
            bgcolor: 'background.paper',
            boxShadow: 24,
            p: 4,
            borderRadius: 2,
          }}
        >
          <Typography variant="h6" component="h2" sx={{ mb: 2 }}>
            Compartir Enlace con Huesped
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
            Comparte este enlace con tu huesped de Airbnb para que complete el formulario de registro antes de su llegada.
          </Typography>
          
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
            <TextField
              fullWidth
              value={selectedReservationId ? getGuestFormLink(selectedReservationId) : ''}
              InputProps={{
                readOnly: true,
              }}
              size="small"
            />
            <IconButton 
              color="primary"
              onClick={() => copyToClipboard(getGuestFormLink(selectedReservationId))}
              sx={{ minWidth: 'auto' }}
            >
              <ContentCopyIcon />
            </IconButton>
          </Box>
          
          <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
            <Button onClick={handleCloseShareLink} color="primary">
              Cerrar
            </Button>
          </Box>
        </Box>
      </Modal>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={3000}
        onClose={() => setSnackbarOpen(false)}
        message="Link copiado al portapapeles"
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      />
      <Dialog
        open={openQrModal}
        onClose={() => setOpenQrModal(false)}
        maxWidth="xs"
        fullWidth
      >
        <DialogContent>
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', py: 2 }}>
            {AuthService.userRoleIncludes(["habitante"]) ? (
              <>
                <Typography variant="body1" sx={{ mb: 2, textAlign: 'center' }}>
                  Comparte este enlace con tu huesped de Airbnb para que complete el formulario de registro antes de su llegada.
                </Typography>
                <Box sx={{ 
                  bgcolor: 'grey.100', 
                  p: 2, 
                  borderRadius: 1, 
                  width: '100%',
                  mb: 2,
                  wordBreak: 'break-all'
                }}>
                  <Typography variant="body2">
                    {`${window.location.origin}/guestform?id=${currentReservationId}`}
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  color="secondary"
                  startIcon={<ContentCopyIcon />}
                  onClick={() => handleCopyLink(currentReservationId)}
                >
                  {linkCopied ? "¡Copiado!" : "Copiar Enlace"}
                </Button>
              </>
            ) : (
              <>
                <QRCodeSVG
                  value={`${window.location.origin}/guestform?id=${currentReservationId}`}
                  size={256}
                  level="L"
                />
                <Typography variant="caption" color="text.secondary" sx={{ mt: 2, textAlign: 'center' }}>
                  Solicita al huesped que escanea el QR para completar el formulario
                </Typography>
              </>
            )}
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenQrModal(false)}>Cerrar</Button>
        </DialogActions>
      </Dialog>
      {AuthService.userRoleIncludes(["habitante"]) && (
        <Box
          sx={{
            position: 'fixed',
            bottom: 88,
            left: 'calc(var(--app-drawer-width, 0px) + (100vw - var(--app-drawer-width, 0px)) / 2)',
            transform: 'translateX(-50%)',
            width: '100%',
            maxWidth: 600,
            px: 2,
            zIndex: 10,
            pointerEvents: 'none'
          }}
        >
          <Button
            variant="contained"
            color="primary"
            fullWidth
            size="large"
            startIcon={<HotelIcon />}
            onClick={handleNewRequest}
            sx={{
              height: 56,
              borderRadius: '10px',
              fontWeight: 800,
              pointerEvents: 'auto'
            }}
          >
            Registrar Estadia
          </Button>
        </Box>
      )}
    </Container>
  );
}